exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".detail-Info[data-v-e83a3084]{height:calc(100% - 50px)}.contact-info[data-v-e83a3084]{font-size:medium;font-weight:700;padding:.5rem}.deep-info[data-v-e83a3084]{padding-left:.5rem;padding-right:.5rem;font-size:14px;color:#a9a9a9}.org-info[data-v-e83a3084]{padding:.5rem .5rem 1rem;font-size:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e83a3084","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/RelationshipItem.vue
// module id = 801
// module chunks = 0